(() => {
  const desktop = matchMedia('(min-width: 1200px)');
  const hover = matchMedia('(hover: hover)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const initialize = (scope = document) => scope.querySelectorAll('.ae-desktop-nav').forEach((nav) => {
    if (nav.dataset.initialized) return;
    nav.dataset.initialized = 'true';
    const roots = [...nav.querySelectorAll('[data-mega-menu-root]')];
    let active, timer;
    const hideTimers = new WeakMap();
    const close = () => {
      clearTimeout(timer);
      if (!active) return;
      active.querySelector('.header__menu-item').setAttribute('aria-expanded', 'false');
      active.querySelector('.mega-menu').classList.remove('is-open');
      const closingPanel = active.querySelector('.mega-menu__content');
      closingPanel.inert = true;
      clearTimeout(hideTimers.get(closingPanel));
      hideTimers.set(closingPanel, setTimeout(() => { closingPanel.hidden = true; }, reduced.matches ? 0 : 250));
      active = null;
      nav.classList.remove('has-open-menu');
    };
    const open = (root) => {
      clearTimeout(timer);
      if (!desktop.matches || active === root) return;
      close();
      active = root;
      const bottom = nav.closest('.header-wrapper').getBoundingClientRect().bottom;
      nav.style.setProperty('--ae-nav-bottom', `${bottom}px`);
      const panel = root.querySelector('.mega-menu__content');
      clearTimeout(hideTimers.get(panel));
      panel.hidden = false;
      // Commit the closed styles before starting the existing fade-in animation.
      panel.getBoundingClientRect();
      root.querySelector('.header__menu-item').setAttribute('aria-expanded', 'true');
      root.querySelector('.mega-menu').classList.add('is-open');
      root.querySelector('.mega-menu__content').inert = false;
      nav.classList.add('has-open-menu');
      if (!reduced.matches) root.querySelectorAll('.mega-menu__column, .mega-menu__promo').forEach((item, index) => {
        item.getAnimations().forEach((animation) => animation.cancel());
        item.animate({ opacity: [0, 1], transform: ['translateY(20px)', 'translateY(0)'] },
          { duration: 180, delay: Math.min(20 * index, 80), easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'backwards' });
      });
    };
    roots.forEach((root) => {
      const link = root.querySelector('.header__menu-item');
      root.addEventListener('mouseenter', () => {
        if (hover.matches) { clearTimeout(timer); timer = setTimeout(() => open(root), 100); }
      });
      root.addEventListener('mouseleave', () => {
        clearTimeout(timer);
        if (hover.matches && active === root) close();
      });
      link.addEventListener('click', (event) => {
        // Touch desktops reveal the menu first; a second tap follows the category.
        if (!hover.matches && active !== root) { event.preventDefault(); open(root); }
      });
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown' && event.target === link) {
          event.preventDefault();
          open(root);
          requestAnimationFrame(() => requestAnimationFrame(() => {
            if (active === root) root.querySelector('.mega-menu__content a')?.focus({ preventScroll: true });
          }));
        } else if (event.key === 'Escape' && active === root) {
          event.preventDefault(); close(); link.focus();
        }
      });
      root.addEventListener('focusout', () => requestAnimationFrame(() => {
        if (active === root && !root.contains(document.activeElement) && !root.matches(':hover')) close();
      }));
    });
    nav.querySelector('.ae-nav-overlay').addEventListener('pointerenter', close);
    nav.querySelector('.ae-nav-overlay').addEventListener('click', close);
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
    document.addEventListener('click', (event) => { if (!nav.contains(event.target)) close(); });
    document.documentElement.addEventListener('mouseleave', close);
    window.addEventListener('resize', close);
    window.addEventListener('scroll', () => { if (active) close(); }, { passive: true });
    desktop.addEventListener('change', close);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
